import React, { FC, MutableRefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import { useRouter } from 'next/router';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import trns from '../../trns';
import StarsComponent from './StarsComponent';
import { TabTypes } from '../../utils';

interface Props {
  averageRate: number;
  rateCount: number;
  isLeaveReviewText?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reviewsTab?: MutableRefObject<any>;
  isStars?: boolean;
  drugPageURL?: string;
  gtagPrefix?: GTAGPrefix;
  isOnDrugPage?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const leaveReviewIcon = 'drug/insert_comment.svg';

const Reviews: FC<Props> = ({
  averageRate,
  rateCount,
  isLeaveReviewText = true,
  drugPageURL,
  gtagPrefix,
  isStars = true,
  isOnDrugPage = false,
  disabled = false,
  onClick
}) => {
  const router = useRouter();
  const { trackGtagEvent } = useGTAG();

  const isReviews = rateCount !== 0;

  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    } else {
      router.push(
        {
          pathname: drugPageURL,
          hash: TabTypes.REVIEWS
        },
        undefined,
        {
          scroll: true,
          shallow: isOnDrugPage
        }
      );
      setTimeout(() => {
        trackGtagEvent(`${gtagPrefix}_top_stars`);
      }, 250);
    }
  };

  return (
    <div className="flex flex-row">
      <div className={cn('flex justify-center', !isReviews && 'mb-[4px]')}>
        {isReviews && (
          <div className="fs-body-bold text-black mr-1 text-center ">
            {averageRate}
          </div>
        )}
        {isStars ? (
          <div>
            <button onClick={handleButtonClick} disabled={disabled}>
              <StarsComponent averageRate={averageRate} />
            </button>
          </div>
        ) : (
          <div className="flex align-center pt-[4px] xxs:p-[4px]">
            <NextImage
              alt="leaveReviewIcon"
              src={leaveReviewIcon}
              layout="fixed"
              width={16}
              height={16}
            />
          </div>
        )}
        <div>
          {isLeaveReviewText && !isReviews ? (
            <button
              className={'text-bondieBlue fs-body-reg'}
              onClick={handleButtonClick}
              disabled={disabled}
            >
              <FormattedMessage {...trns.leaveNewReview} />
            </button>
          ) : (
            <div className={'text-astronautBlue fs-body-reg'}>
              ({rateCount})
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
